/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backstage_Point_1Inputs */

const en_backstage_point_1 = /** @type {(inputs: Backstage_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queues that count what is waiting for you`)
};

/**
* | output |
* | --- |
* | "Queues that count what is waiting for you" |
*
* @param {Backstage_Point_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const backstage_point_1 = /** @type {((inputs?: Backstage_Point_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backstage_Point_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_backstage_point_1(inputs)
});